import PropTypes from 'prop-types';
import React from 'react';
import {Button} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import {COLORS} from '../../constants';
import {InputGroup, InputGroupAddon} from 'reactstrap';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const Input = styled.input`
  height: 38px;
  width: 100%;
  background-color: white;
  color: ${COLORS.BLACK};
  border-color: ${COLORS.BACKGROUND_GRAY};
  font-size: 14px;
  ::placeholder {
    color: ${COLORS.SEARCH_BLACK};
  }
`;

const InputGroupFixed = styled(InputGroup)`
  &&& {
    width: 180px;
  }
`;

const CancelButton = styled(Button).attrs()`
  &&& {
    position: absolute;
    margin-left: -30px;
    background-color: transparent;
    height: 100%;
  }

  &&&:focus {
    box-shadow: none;
  }

  &&&&&:active {
    box-shadow: none;
    background-color: transparent;
    background: transparent;
  }
`;

const Search = ({t, onChange, onCancel}) => {
  const [search, setSearch] = React.useState('');
  return (
    <InputGroupFixed>
      <Input
        type="text"
        placeholder={t('datatable.search')}
        onChange={e => {
          setSearch(e.target.value);
          onChange(e);
        }}
        value={search}/>
      <InputGroupAddon addonType="append">
        <CancelButton
          onClick={() => {
            setSearch('');
            onCancel();
          }}
        >
          <FontAwesomeIcon
            icon={faTimes}
            color={COLORS.BLACK}
          /></CancelButton>
      </InputGroupAddon>
    </InputGroupFixed>
  );
};

Search.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default withTranslation('common')(Search);
